// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.NicheCardList .NicheCardList-list {
  display: flex;
  flex-direction: column;
  max-height: 568px;
  gap: 8px;
  overflow-y: scroll;
  overflow-x: visible;
  margin-bottom: 8px;
}
.NicheCardList .NicheCardList-list::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.NicheCardList .NicheCardList-list::-webkit-scrollbar-track {
  background: transparent;
}
.NicheCardList .NicheCardList-list::-webkit-scrollbar-thumb {
  background: var(--color_neutral_200);
  height: 80px;
  border-radius: 50px;
}
.NicheCardList .NicheCardList-list:hover::-webkit-scrollbar-thumb {
  background: var(--color_neutral_400);
}
.NicheCardList .NicheCardList-list::-webkit-scrollbar-thumb:active {
  background: var(--color_neutral_500);
}

.NicheCardListSkeleton {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
.NicheCardListSkeleton span {
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/modules/niche/niche-card-list/niche-card-list.styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAXE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAaJ;ADVE;EACE,UAAA;EACA,WAAA;ACYJ;ADTE;EACE,uBAAA;ACWJ;ADRE;EACE,oCAdM;EAeN,YAAA;EACA,mBAAA;ACUJ;ADNI;EACE,oCApBS;AC4Bf;ADJE;EACE,oCAxBY;AC8BhB;;AAzBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA4BF;AA1BE;EACE,SAAA;AA4BJ","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.NicheCardList {\n\n  .NicheCardList-list {\n    display: flex;\n    flex-direction: column;\n    max-height: 568px;\n    gap: 8px;\n    overflow-y: scroll;\n    overflow-x: visible;\n    margin-bottom: 8px;\n\n    @include scrollbar;\n  }\n}\n\n.NicheCardListSkeleton {\n  display: flex;\n  flex-direction: column;\n  row-gap: 8px;\n\n  span {\n    flex: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
